import { render, staticRenderFns } from "./VwVendor.vue?vue&type=template&id=05569cc9&lang=pug&"
import script from "./VwVendor.vue?vue&type=script&lang=ts&"
export * from "./VwVendor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "VwVendor.vue"
export default component.exports